"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var DialogActionButton_1 = __importDefault(require("../../dialog-action-button/DialogActionButton"));
var TextField_1 = __importDefault(require("../../text-field/TextField"));
var react_1 = __importStar(require("react"));
var Search_1 = __importDefault(require("@mui/icons-material/Search"));
var lodash_1 = __importDefault(require("lodash"));
var utils_1 = require("../utils/utils");
var Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
var HighlightOffSharp_1 = __importDefault(require("@mui/icons-material/HighlightOffSharp"));
var utils_2 = require("../../../utils/utils");
var Select_1 = __importDefault(require("@mui/material/Select"));
var tableColumns = [
    { id: "code", label: "Code" },
    { id: "name", label: "Level of Care" },
    { id: "facility", label: "Facility" },
    { id: "rate", label: "Rate" },
    { id: "days", label: "Days/Sessions" },
    { id: "covered", label: "Covered" },
];
var LOCModalContents = function (_a) {
    var open = _a.open, _b = _a.loc, selectedLocType = _b.selectedLocType, preSelectedLocs = _b.preSelectedLocs, facilityLocList = _b.facilityLocList, facilityId = _a.selectedFacility.facilityId, _c = _a.vob, inNetwork = _c.inNetwork, selfPay = _c.selfPay, quoteMethod = _a.quoteMethod, saveStatus = _a.saveStatus, handleSave = _a.handleSave, handleLocModalCallback = _a.handleLocModalCallback, _d = _a.columnsToShow, columnsToShow = _d === void 0 ? ['code', 'name', 'facility', 'rate', 'days', 'covered'] : _d;
    var _e = (0, react_1.useState)([]), rows = _e[0], setRows = _e[1];
    var _f = (0, react_1.useState)(0), page = _f[0], setPage = _f[1];
    var _g = (0, react_1.useState)(5), rowsPerPage = _g[0], setRowsPerPage = _g[1];
    var _h = (0, react_1.useState)(), originalRows = _h[0], setOriginalRows = _h[1];
    var _j = (0, react_1.useState)(""), searched = _j[0], setSearched = _j[1];
    var _k = (0, react_1.useState)(false), selectedFacGridIsValid = _k[0], setSelectedFacGridIsValid = _k[1];
    var _l = (0, react_1.useState)(false), multiFacGridIsValid = _l[0], setMultiFacGridIsValid = _l[1];
    var _m = (0, react_1.useState)(true), enableSaveButtonState = _m[0], setEnableSaveButtonState = _m[1];
    var _o = (0, react_1.useState)(selectedLocType ? selectedLocType : 'selected'), selectedLocTypeState = _o[0], setSelectedLocTypeState = _o[1];
    var _p = (0, react_1.useState)(preSelectedLocs ? preSelectedLocs : []), selectedFacilityLocs = _p[0], setSelectedFacilityLocs = _p[1];
    (0, react_1.useEffect)(function () {
        if (selectedLocTypeState === 'multi') {
            var facilityLevelOfCareIds_1 = [];
            // get unique list of level of care names
            var clientLocNames = facilityLocList
                .map(function (loc) { return loc.facilityLevelOfCareName; })
                .filter(function (value, index, _arr) {
                return _arr.indexOf(value) === index;
            });
            clientLocNames = clientLocNames.sort();
            var multiFacilityLocs_1 = [];
            // build multi-facility levels of care
            clientLocNames.forEach(function (locName) {
                var _a, _b, _c, _d;
                facilityLevelOfCareIds_1 = [];
                var allLocFacilities = [];
                facilityLocList
                    .filter(function (loc) { return loc.facilityLevelOfCareName === locName; })
                    .forEach(function (facility) {
                    facilityLevelOfCareIds_1.push(facility.facilityLevelOfCareId);
                    allLocFacilities.push({
                        facilityName: facility.facilityName,
                        facilityId: facility.clientFacilityId,
                        facilityLevelOfCareId: facility.facilityLevelOfCareId,
                        selected: false
                    });
                });
                // sort facility list alphabetically
                allLocFacilities.sort(function (a, b) {
                    return a.facilityName.localeCompare(b.facilityName);
                });
                // determine default selected facility
                var defaultSelectedFacilityId = allLocFacilities[0].facilityId;
                // see if estimator selected facility is present
                var thisFacilityIndex = allLocFacilities.findIndex(function (fac) { return fac.facilityId === facilityId; });
                if (thisFacilityIndex > -1) {
                    defaultSelectedFacilityId = allLocFacilities[thisFacilityIndex].facilityId;
                }
                var namedLoc = allLocFacilities.length > 0
                    ? facilityLocList.find(function (fac) {
                        return fac.facilityLevelOfCareName === locName &&
                            fac.clientFacilityId === defaultSelectedFacilityId;
                    })
                    : facilityLocList.find(function (p) { return p.facilityLevelOfCareName === locName; });
                if (namedLoc) {
                    var namedLocCopy_1 = utils_2.Utils.deepClone(namedLoc);
                    // multi facility locs get an id based on each facility.facilityLevelOfCareId
                    namedLocCopy_1.multiFacilityId = facilityLevelOfCareIds_1.sort(function (a, b) { return a - b; }).join(".");
                    var ratesLos = (0, utils_1.getRateAndLosFromQuoteMethod)(namedLocCopy_1, quoteMethod, inNetwork);
                    if (!namedLocCopy_1.facilityLevelOfCareCode) {
                        namedLocCopy_1.facilityLevelOfCareCode = "";
                    }
                    if (!namedLocCopy_1.facilityLevelOfCareName) {
                        namedLocCopy_1.facilityLevelOfCareName = "";
                    }
                    // set the allLocFacilities list item to selected
                    var selectedFacListIdx = allLocFacilities.findIndex(function (fac) { return (fac === null || fac === void 0 ? void 0 : fac.facilityId) === namedLocCopy_1.clientFacilityId; });
                    if (selectedFacListIdx) {
                        allLocFacilities[selectedFacListIdx].selected = true;
                    }
                    namedLocCopy_1.facilities = allLocFacilities;
                    namedLocCopy_1.manualRatesLos = {
                        pdrRate: (_a = ratesLos.pdrRate) !== null && _a !== void 0 ? _a : 0,
                        losDays: 0,
                    };
                    namedLocCopy_1.scaRatesLos = {
                        pdrRate: 0,
                        losDays: 0,
                    };
                    namedLocCopy_1.selectedRateLos = {
                        pdrRate: (_b = ratesLos.pdrRate) !== null && _b !== void 0 ? _b : 0,
                        losDays: (_c = ratesLos.losDays) !== null && _c !== void 0 ? _c : 0,
                    };
                    if (selfPay) {
                        if ((_d = namedLocCopy_1 === null || namedLocCopy_1 === void 0 ? void 0 : namedLocCopy_1.facilityPayorLocRateLos) === null || _d === void 0 ? void 0 : _d.isCovered) {
                            namedLocCopy_1.facilityPayorLocRateLos.isCovered = false;
                        }
                    }
                    multiFacilityLocs_1.push(namedLocCopy_1);
                }
            });
            setRows(multiFacilityLocs_1);
            setOriginalRows(multiFacilityLocs_1);
            var selectedMultiFacilityLocsCopy = utils_2.Utils.deepClone(selectedFacilityLocs);
            setSelectedFacilityLocs(selectedMultiFacilityLocsCopy);
        }
        else {
            var facilityLocs = (0, utils_1.BuildSelectedLevelsofCare)(facilityLocList, facilityId, quoteMethod, inNetwork, selfPay);
            setRows(facilityLocs);
            setOriginalRows(facilityLocs);
            // clean up prior selectedFacility state
            var selectedFacilityLocsCopy = (0, utils_1.UpdateSelectedFacilityLocs)(selectedFacilityLocs, facilityLocs);
            setSelectedFacilityLocs(selectedFacilityLocsCopy);
        }
    }, [
        selectedLocTypeState,
        facilityLocList,
        facilityId,
        quoteMethod,
        inNetwork,
        selfPay
    ]);
    var editableRateLos = function (loc, value, rate) {
        var returnData = react_1.default.createElement(react_1.default.Fragment, null);
        // short curcuit for surcharges (type 1)
        if (loc.cfgLocType === 1)
            return react_1.default.createElement(react_1.default.Fragment, null, value);
        switch (quoteMethod) {
            case "avglos":
                returnData = react_1.default.createElement(react_1.default.Fragment, null, value);
                break;
            case "sca":
                if (rate) {
                    returnData = react_1.default.createElement(material_1.TextField, { type: "number", style: { width: "6em" }, value: value, onChange: function (e) { return changeRateLos(loc, e.target.value, rate); } });
                }
                else {
                    returnData = react_1.default.createElement(material_1.TextField, { type: "number", style: { width: "4.5em" }, value: value, onChange: function (e) { return changeRateLos(loc, e.target.value, rate); } });
                }
                break;
            case "rlos":
                returnData = react_1.default.createElement(react_1.default.Fragment, null, value);
                break;
            case "manual":
                if (rate) {
                    returnData = react_1.default.createElement(react_1.default.Fragment, null, value);
                }
                else {
                    returnData = react_1.default.createElement(material_1.TextField, { type: "number", style: { width: "4.5em" }, value: value, onChange: function (e) { return changeRateLos(loc, e.target.value, rate); } });
                }
                break;
            default:
            // nothing
        }
        return returnData;
    };
    var handleSelections = function (selectedLocs, isValid) {
        checkIsFormValid2();
        setSelectedFacilityLocs(selectedLocs);
        switch (selectedLocTypeState) {
            case "selected":
                setSelectedFacGridIsValid(isValid);
                break;
            case "multi":
                setMultiFacGridIsValid(isValid);
                break;
            default:
            // do nothing
        }
    };
    var handleLocTypeChange = function (event, value) {
        setSelectedFacilityLocs([]);
        setRowsPerPage(5);
        setPage(0);
        setSelectedLocTypeState(value);
        setEnableSaveButtonState(false);
    };
    var checkIsFormValid2 = (0, react_1.useCallback)(function () {
        var gridIsValid = false;
        switch (selectedLocTypeState) {
            case "selected":
                gridIsValid = selectedFacGridIsValid;
                break;
            case "multi":
                gridIsValid = multiFacGridIsValid;
                break;
            default:
            // do nothing
        }
        setEnableSaveButtonState(gridIsValid);
    }, [multiFacGridIsValid, selectedFacGridIsValid, selectedLocTypeState]);
    (0, react_1.useEffect)(function () {
        checkIsFormValid2();
    }, [checkIsFormValid2]);
    var changeRateLos = function (loc, value, rate) {
        var keyNum = (value !== "") ? +value : undefined;
        var selectedCopy = utils_2.Utils.deepClone(selectedFacilityLocs);
        var updatedLoc = (0, utils_1.updateRateLosByQuoteMethod)(loc, quoteMethod, keyNum, rate);
        var index;
        if (selectedLocTypeState === 'multi') {
            index = selectedCopy.findIndex(function (el) { return el.multiFacilityId === loc.multiFacilityId; });
        }
        else {
            index = selectedCopy.findIndex(function (el) { return el.cfgLevelOfCareId === loc.cfgLevelOfCareId; });
        }
        if (selectedCopy[index]) {
            selectedCopy[index] = updatedLoc;
        }
        setSelectedFacilityLocs(selectedCopy);
        handleSelections(selectedCopy, checkIsFormValid(selectedCopy));
    };
    var checkIsFormValid = function (selectedCopy) {
        return (selectedCopy.length > 0 &&
            selectedCopy.every(function (currentLoc) { var _a, _b; return (!isNaN((_a = currentLoc.selectedRateLos) === null || _a === void 0 ? void 0 : _a.losDays) && !isNaN((_b = currentLoc.selectedRateLos) === null || _b === void 0 ? void 0 : _b.pdrRate)); }));
    };
    var requestSearch = function (searchedVal) {
        setSearched(searchedVal);
        var filteredRows = originalRows === null || originalRows === void 0 ? void 0 : originalRows.filter(function (row) {
            var _a;
            return ((row === null || row === void 0 ? void 0 : row.facilityLevelOfCareName.toLowerCase().includes(searchedVal.toLowerCase())) ||
                ((_a = row === null || row === void 0 ? void 0 : row.facilityLevelOfCareCode) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase().includes(searchedVal.toLowerCase())));
        });
        setRows(filteredRows);
        setPage(0);
    };
    var cancelSearch = function () {
        setSearched("");
        requestSearch(searched);
    };
    var clearSelectedLocs = function () {
        setSelectedFacilityLocs([]);
    };
    var handleChangePage = function (event, newPage) {
        setPage(newPage);
    };
    var handleChangeRowsPerPage = function (event) {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    var handleFacilityChange = function (event) {
        var _a, _b, _c;
        var valueSplit = event.target.value.split("|");
        var multiFacilityId = valueSplit[0];
        var facilityId = parseInt(valueSplit[1]);
        var selectedFacilityLoc = selectedFacilityLocs === null || selectedFacilityLocs === void 0 ? void 0 : selectedFacilityLocs.find(function (loc) { return loc.multiFacilityId === multiFacilityId; });
        if (selectedFacilityLoc) {
            var selectedFacilityLocCopy_1 = utils_2.Utils.deepClone(selectedFacilityLoc);
            var selectedFacility_1 = (_a = selectedFacilityLoc.facilities) === null || _a === void 0 ? void 0 : _a.find(function (fac) { return fac.facilityId === facilityId; });
            var newFacilityLoc_1 = facilityLocList.find(function (loc) {
                return loc.facilityLevelOfCareId === (selectedFacility_1 === null || selectedFacility_1 === void 0 ? void 0 : selectedFacility_1.facilityLevelOfCareId);
            });
            // apply new facility loc values to selected row
            if (newFacilityLoc_1) {
                // update selected facility
                (_b = selectedFacilityLocCopy_1.facilities) === null || _b === void 0 ? void 0 : _b.forEach(function (fac) {
                    fac.selected = false;
                });
                var selectedFacListIdx = (_c = selectedFacilityLocCopy_1.facilities) === null || _c === void 0 ? void 0 : _c.findIndex(function (fac) { return (fac === null || fac === void 0 ? void 0 : fac.facilityId) === newFacilityLoc_1.clientFacilityId; });
                if (selectedFacListIdx) {
                    selectedFacilityLocCopy_1.facilities[selectedFacListIdx].selected = true;
                }
                selectedFacilityLocCopy_1.clientFacilityId = newFacilityLoc_1 === null || newFacilityLoc_1 === void 0 ? void 0 : newFacilityLoc_1.clientFacilityId;
                selectedFacilityLocCopy_1.facilityLevelOfCareId = newFacilityLoc_1 === null || newFacilityLoc_1 === void 0 ? void 0 : newFacilityLoc_1.facilityLevelOfCareId;
                selectedFacilityLocCopy_1.cfgLevelOfCareId = newFacilityLoc_1 === null || newFacilityLoc_1 === void 0 ? void 0 : newFacilityLoc_1.cfgLevelOfCareId;
                selectedFacilityLocCopy_1.facilityLocRlos = newFacilityLoc_1 === null || newFacilityLoc_1 === void 0 ? void 0 : newFacilityLoc_1.facilityLocRlos;
                selectedFacilityLocCopy_1.facilityPayorLocRateLos = newFacilityLoc_1 === null || newFacilityLoc_1 === void 0 ? void 0 : newFacilityLoc_1.facilityPayorLocRateLos;
                selectedFacilityLocCopy_1.vobClassificationId = newFacilityLoc_1 === null || newFacilityLoc_1 === void 0 ? void 0 : newFacilityLoc_1.vobClassificationId;
                selectedFacilityLocCopy_1.thirdPartyAverageInnLos = newFacilityLoc_1 === null || newFacilityLoc_1 === void 0 ? void 0 : newFacilityLoc_1.thirdPartyAverageInnLos;
                selectedFacilityLocCopy_1.thirdPartyAverageInnPdr = newFacilityLoc_1 === null || newFacilityLoc_1 === void 0 ? void 0 : newFacilityLoc_1.thirdPartyAverageInnPdr;
                selectedFacilityLocCopy_1.thirdPartyAverageOnnLos = newFacilityLoc_1 === null || newFacilityLoc_1 === void 0 ? void 0 : newFacilityLoc_1.thirdPartyAverageOnnLos;
                selectedFacilityLocCopy_1.thirdPartyAverageOnnPdr = newFacilityLoc_1 === null || newFacilityLoc_1 === void 0 ? void 0 : newFacilityLoc_1.thirdPartyAverageOnnPdr;
                selectedFacilityLocCopy_1.sortOrder = newFacilityLoc_1 === null || newFacilityLoc_1 === void 0 ? void 0 : newFacilityLoc_1.sortOrder;
                selectedFacilityLocCopy_1.perDiemOperatingCost = newFacilityLoc_1 === null || newFacilityLoc_1 === void 0 ? void 0 : newFacilityLoc_1.perDiemOperatingCost;
                selectedFacilityLocCopy_1.minRevenueAmount = newFacilityLoc_1 === null || newFacilityLoc_1 === void 0 ? void 0 : newFacilityLoc_1.minRevenueAmount;
                selectedFacilityLocCopy_1.minRevenueFlatRate = newFacilityLoc_1 === null || newFacilityLoc_1 === void 0 ? void 0 : newFacilityLoc_1.minRevenueFlatRate;
                var ratesLos = (0, utils_1.getRateAndLosFromQuoteMethod)(newFacilityLoc_1, quoteMethod, inNetwork);
                selectedFacilityLocCopy_1.selectedRateLos = {
                    pdrRate: ratesLos.pdrRate,
                    losDays: ratesLos.losDays,
                };
            }
            var selectedFacilityLocsCopy = utils_2.Utils.deepClone(selectedFacilityLocs);
            selectedFacilityLocsCopy.splice(selectedFacilityLocsCopy.findIndex(function (el) {
                return (el.multiFacilityId ===
                    selectedFacilityLocCopy_1.multiFacilityId);
            }), 1);
            selectedFacilityLocsCopy.push(selectedFacilityLocCopy_1);
            setSelectedFacilityLocs(selectedFacilityLocsCopy);
            var isFormValid = checkIsFormValid(selectedFacilityLocsCopy);
            handleSelections(selectedFacilityLocsCopy, isFormValid);
        }
    };
    var facilitySelector = function (thisRow) {
        var _a, _b, _c, _d;
        var selectedFacilityLoc = selectedFacilityLocs === null || selectedFacilityLocs === void 0 ? void 0 : selectedFacilityLocs.find(function (loc) { return loc.multiFacilityId === thisRow.multiFacilityId; });
        return (react_1.default.createElement(material_1.FormControl, { variant: "standard", sx: { m: 1, minWidth: 100 } },
            react_1.default.createElement(material_1.InputLabel, { id: (_a = selectedFacilityLoc === null || selectedFacilityLoc === void 0 ? void 0 : selectedFacilityLoc.facilityLevelOfCareId) === null || _a === void 0 ? void 0 : _a.toString() }, "Facility"),
            react_1.default.createElement(Select_1.default, { labelId: selectedFacilityLoc === null || selectedFacilityLoc === void 0 ? void 0 : selectedFacilityLoc.multiFacilityId, id: selectedFacilityLoc === null || selectedFacilityLoc === void 0 ? void 0 : selectedFacilityLoc.multiFacilityId, value: "".concat(thisRow.multiFacilityId, "|").concat((_c = (_b = selectedFacilityLoc === null || selectedFacilityLoc === void 0 ? void 0 : selectedFacilityLoc.facilities) === null || _b === void 0 ? void 0 : _b.find(function (fac) { return fac.facilityId === (selectedFacilityLoc === null || selectedFacilityLoc === void 0 ? void 0 : selectedFacilityLoc.clientFacilityId); })) === null || _c === void 0 ? void 0 : _c.facilityId), onChange: handleFacilityChange, label: "Facility" }, (selectedFacilityLoc === null || selectedFacilityLoc === void 0 ? void 0 : selectedFacilityLoc.facilities) &&
                ((_d = __spreadArray([], selectedFacilityLoc.facilities, true)) === null || _d === void 0 ? void 0 : _d.sort(function (a, b) { return (a.facilityName > b.facilityName ? 1 : -1); }).map(function (facility, index) { return (react_1.default.createElement(material_1.MenuItem, { key: index, value: "".concat(thisRow.multiFacilityId, "|").concat(facility.facilityId) }, facility.facilityName)); })))));
    };
    var isSelected = function (id) {
        if (selectedLocTypeState === 'multi') {
            return selectedFacilityLocs.findIndex(function (el) { return el.multiFacilityId === id; }) !== -1;
        }
        else {
            return selectedFacilityLocs.findIndex(function (el) { return el.cfgLevelOfCareId === id; }) !== -1;
        }
    };
    var handleCheckboxClick = function (row) {
        var index;
        var selectedCopy = __spreadArray([], selectedFacilityLocs, true);
        if (selectedLocTypeState === 'multi') {
            index = selectedCopy.findIndex(function (el) { return el.multiFacilityId === row.multiFacilityId; });
            if (index > -1) {
                selectedCopy.splice(selectedCopy.findIndex(function (el) {
                    return el.multiFacilityId === row.multiFacilityId;
                }), 1);
            }
            else {
                selectedCopy.push(row);
            }
        }
        else {
            index = selectedCopy.findIndex(function (el) { return el.cfgLevelOfCareId === row.cfgLevelOfCareId; });
            if (index > -1) {
                selectedCopy.splice(selectedCopy.findIndex(function (el) {
                    return el.cfgLevelOfCareId === row.cfgLevelOfCareId;
                }), 1);
            }
            else {
                selectedCopy.push(row);
            }
        }
        setSelectedFacilityLocs(selectedCopy);
        var isFormValid = checkIsFormValid(selectedCopy);
        handleSelections(selectedCopy, isFormValid);
    };
    var getTableBodyRow = function (row, selectedRow, isItemSelected, filteredColumnsToShow) {
        var ratesLos = isItemSelected
            ? (0, utils_1.getRateAndLosFromQuoteMethod)(selectedRow, quoteMethod, inNetwork)
            : (0, utils_1.getRateAndLosFromQuoteMethod)(row, quoteMethod, inNetwork);
        var tableCells = filteredColumnsToShow.map(function (column) {
            var _a, _b;
            switch (column) {
                case 'code':
                    return (react_1.default.createElement(material_1.TableCell, null, row === null || row === void 0 ? void 0 : row.facilityLevelOfCareCode));
                case 'name':
                    return (react_1.default.createElement(material_1.TableCell, null, row === null || row === void 0 ? void 0 : row.facilityLevelOfCareName));
                case 'facility':
                    return (react_1.default.createElement(material_1.TableCell, null, isItemSelected ? facilitySelector(row) : react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(material_1.Typography, { variant: "body2" }, row.facilityName))));
                case 'rate':
                    return (react_1.default.createElement(material_1.TableCell, null, isItemSelected ? (editableRateLos(selectedRow, row.cfgLocType === 1 ? "-" : ratesLos.pdrRate, true)) : (react_1.default.createElement(react_1.default.Fragment, null, row.cfgLocType === 1 ? "-" : (quoteMethod === "sca" || quoteMethod === "manual") ? "" : ratesLos.pdrRate))));
                case 'days':
                    return (react_1.default.createElement(material_1.TableCell, null, isItemSelected ? (editableRateLos(selectedRow, row.cfgLocType === 1 ? "-" : ratesLos.losDays, false)) : (react_1.default.createElement(react_1.default.Fragment, null, row.cfgLocType === 1 ? "-" : (quoteMethod === "sca" || quoteMethod === "manual") ? "" : ratesLos.losDays))));
                case 'covered':
                    return (react_1.default.createElement(material_1.TableCell, null, isItemSelected ? (((_a = selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.facilityPayorLocRateLos) === null || _a === void 0 ? void 0 : _a.isCovered) ? (react_1.default.createElement(react_1.default.Fragment, null, "Yes")) : (react_1.default.createElement(react_1.default.Fragment, null, "No"))) : ((_b = row === null || row === void 0 ? void 0 : row.facilityPayorLocRateLos) === null || _b === void 0 ? void 0 : _b.isCovered) ? (react_1.default.createElement(react_1.default.Fragment, null, "Yes")) : (react_1.default.createElement(react_1.default.Fragment, null, "No"))));
                default:
                    return undefined;
            }
        });
        return (react_1.default.createElement(material_1.TableRow, { key: selectedLocTypeState === 'multi' ? row.multiFacilityId : row.cfgLevelOfCareId },
            react_1.default.createElement(material_1.TableCell, null,
                react_1.default.createElement(Checkbox_1.default, { onClick: function () { return handleCheckboxClick(row); }, className: "selectCheckbox", checked: isItemSelected })),
            tableCells));
    };
    var getTableBody = function (filteredColumnsToShow) {
        if (selectedLocTypeState === 'multi') {
            return (react_1.default.createElement(material_1.TableBody, null, lodash_1.default.sortBy(rows, "facilityLevelOfCareName").slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (row) {
                var isItemSelected = isSelected(row.multiFacilityId);
                var selectedRow = selectedFacilityLocs[selectedFacilityLocs.findIndex(function (el) { return el.multiFacilityId === row.multiFacilityId; })];
                return getTableBodyRow(row, selectedRow, isItemSelected, filteredColumnsToShow);
            })));
        }
        else {
            return (react_1.default.createElement(material_1.TableBody, null, rows === null || rows === void 0 ? void 0 : rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (row) {
                var isItemSelected = isSelected(row === null || row === void 0 ? void 0 : row.cfgLevelOfCareId);
                var selectedRow = selectedFacilityLocs[selectedFacilityLocs.findIndex(function (el) { return el.cfgLevelOfCareId === row.cfgLevelOfCareId; })];
                return getTableBodyRow(row, selectedRow, isItemSelected, filteredColumnsToShow);
            })));
        }
    };
    var getTableHeader = function (filteredColumnsToShow) {
        return (react_1.default.createElement(material_1.TableHead, null,
            react_1.default.createElement(material_1.TableRow, null,
                react_1.default.createElement(material_1.TableCell, null),
                filteredColumnsToShow.map(function (col) {
                    var tableColumn = tableColumns.find(function (item) { return item.id === col; });
                    if (tableColumn)
                        return (react_1.default.createElement(material_1.TableCell, { key: tableColumn.id }, tableColumn.label));
                }))));
    };
    var getTable = function () {
        var filteredColumnsToShow = columnsToShow;
        if (quoteMethod !== 'sca')
            filteredColumnsToShow = filteredColumnsToShow.filter(function (col) { return col !== 'rate'; });
        if (selectedLocTypeState === 'selected')
            filteredColumnsToShow = filteredColumnsToShow.filter(function (col) { return col !== 'facility'; });
        return (react_1.default.createElement(material_1.Table, { size: "small" },
            getTableHeader(filteredColumnsToShow),
            getTableBody(filteredColumnsToShow)));
    };
    return (react_1.default.createElement(material_1.Dialog, { className: "modal", open: open, fullWidth: true, maxWidth: "lg", scroll: "body" },
        react_1.default.createElement(material_1.DialogTitle, null,
            preSelectedLocs.length > 0 ? "Edit" : "Add",
            " Levels of Care"),
        react_1.default.createElement(material_1.DialogContent, null,
            react_1.default.createElement(material_1.Grid, { item: true, xs: 5, className: "pb-2", direction: "column", style: { marginTop: '1rem' } },
                react_1.default.createElement(TextField_1.default, { placeholder: "Search by code or name", name: "searched", value: searched, onChange: function (event) { var _a; return requestSearch((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value); }, onBlur: function () { return cancelSearch(); }, startAdornment: react_1.default.createElement(Search_1.default, null) })),
            react_1.default.createElement(material_1.TableContainer, { component: material_1.Paper },
                getTable(),
                react_1.default.createElement(material_1.Grid, { container: true, justifyContent: "space-between" },
                    react_1.default.createElement(material_1.Grid, { item: true },
                        react_1.default.createElement(material_1.IconButton, { title: "clear selected", style: { fontSize: "1.5rem", marginLeft: "1.25rem" }, onClick: function () { return clearSelectedLocs(); }, size: "large" },
                            react_1.default.createElement(HighlightOffSharp_1.default, { color: "error" }),
                            " Clear selected")),
                    react_1.default.createElement(material_1.Grid, { item: true },
                        react_1.default.createElement(material_1.TablePagination, { component: "div", rowsPerPageOptions: [
                                5,
                                10,
                                50,
                                { value: rows.length, label: "All" },
                            ], count: rows.length, rowsPerPage: rowsPerPage, page: page, labelRowsPerPage: "View", onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage }))))),
        react_1.default.createElement(material_1.DialogActions, null,
            react_1.default.createElement(DialogActionButton_1.default, { isEnabled: enableSaveButtonState, savebuttonText: preSelectedLocs.length > 0 ? "Update" : "Save", saveStatus: saveStatus, spinnerLeftPosition: 5, executeSave: handleSave(selectedFacilityLocs, selectedLocTypeState), handleCallbackSave: function () {
                    setEnableSaveButtonState(false);
                    return handleLocModalCallback;
                }, handleCallbackCancel: handleLocModalCallback }))));
};
exports.default = LOCModalContents;
